import React, { useEffect, useState } from "react";
import FormleftNev from "../../../components/common/FormleftNev"
import FormnavBar from "../../../components/common/wizard_navbar";
import Lang from "../../../lang";
import TlkTable from "../../../components/tlelrik/table/tlkTable";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { DatePicker } from "@progress/kendo-react-dateinputs";

import { Switch } from "@progress/kendo-react-inputs";
import { Tooltip } from "antd";
import { Button } from "@progress/kendo-react-buttons";
import { Input } from "@progress/kendo-react-inputs";
import queryString from "query-string";
import $ from "jquery";
import services from "../../../services";
import { toast } from "react-toastify";
import CurrencyInput from 'react-currency-input-field';
import jsPDF from "jspdf";
import "@patternfly/react-core/dist/styles/base.css";
import { DualListSelector } from '@patternfly/react-core';
import EntityDetails from '../../../components/common/EntityDetails';
import SearchFilter from '../../../components/filters/SearchFilter';
import { Select } from 'antd';
import TableCriacaoPenhora from "./TableCriacaoPenhora";
import { insertItem, getItems, updateItem, deleteItem , GetItems} from "./services2";
import TablePreenchida from "./TablePreenchida";
import { Document, Page } from 'react-pdf';
import Swal from "sweetalert2";
import IBANInput from './IBANInput';
import { iban } from '@form-validation/validator-iban';
const { Option } = Select
var itemsDetalhes = {};
//import lang from "../../../lang";
//import LabelTabel from "./LabelTable.jsx";
var moment = require("moment");

const dateFormat = "YYYY-MM-DD";
const dateShowFormat = "dd/MM/yyyy";
let listdefaultRequest = { Filters: null, "SortBy": "id", "IsSortTypeDESC": true, "IsPagination": true, "Page": 1, "PageSize": 100 }
let imageObj =
    "data:image/png;base64,/9j/4QAYRXhpZgAASUkqAAgAAAAAAAAAAAAAAP/sABFEdWNreQABAAQAAAAyAAD/4QMdaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLwA8P3hwYWNrZXQgYmVnaW49Iu+7vyIgaWQ9Ilc1TTBNcENlaGlIenJlU3pOVGN6a2M5ZCI/PiA8eDp4bXBtZXRhIHhtbG5zOng9ImFkb2JlOm5zOm1ldGEvIiB4OnhtcHRrPSJBZG9iZSBYTVAgQ29yZSA1LjYtYzAxNCA3OS4xNTY3OTcsIDIwMTQvMDgvMjAtMDk6NTM6MDIgICAgICAgICI+IDxyZGY6UkRGIHhtbG5zOnJkZj0iaHR0cDovL3d3dy53My5vcmcvMTk5OS8wMi8yMi1yZGYtc3ludGF4LW5zIyI+IDxyZGY6RGVzY3JpcHRpb24gcmRmOmFib3V0PSIiIHhtbG5zOnhtcE1NPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvbW0vIiB4bWxuczpzdFJlZj0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL3NUeXBlL1Jlc291cmNlUmVmIyIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjFCRjUxNkRENTgzMzExRTg5RThGOEE4MTMxMzlGMEREIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjFCRjUxNkRDNTgzMzExRTg5RThGOEE4MTMxMzlGMEREIiB4bXA6Q3JlYXRvclRvb2w9IkFkb2JlIFBob3Rvc2hvcCBDQyAyMDE0IFdpbmRvd3MiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0iMzE5NDc4RDI5OEYyOEQ0NEYyMjcwNjM0Mjk3QTBBRTIiIHN0UmVmOmRvY3VtZW50SUQ9IjMxOTQ3OEQyOThGMjhENDRGMjI3MDYzNDI5N0EwQUUyIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+/+4ADkFkb2JlAGTAAAAAAf/bAIQACAYGBgYGCAYGCAwIBwgMDgoICAoOEA0NDg0NEBEMDg0NDgwRDxITFBMSDxgYGhoYGCMiIiIjJycnJycnJycnJwEJCAgJCgkLCQkLDgsNCw4RDg4ODhETDQ0ODQ0TGBEPDw8PERgWFxQUFBcWGhoYGBoaISEgISEnJycnJycnJycn/8AAEQgAZABkAwEiAAIRAQMRAf/EAJoAAAEFAQEBAAAAAAAAAAAAAAABAwQFBgIHCAEAAgMBAQAAAAAAAAAAAAAAAAIBAwQFBhAAAgEDAgMGAwUGBgMAAAAAAQIDABEEIRIxQQVRYXEiEwaBoTKRsUIzFMFSYiMkB/DR8XKSsuFDcxEAAgEDAwEFCAIDAAAAAAAAAQIAERIDITEEUUFhsSJCcYGRodEyEwXBUvDxI//aAAwDAQACEQMRAD8A9HGgvehD5ePM/fR/jWuYz5B338eNEJ2bEWOoo15/OkPzo5ffRCF9SKGZYwXbQDif9KOd/hTOSyhFB4lxtJNtRrVeXIMeNnPpBP0j40LuqD1GkfFwDfvrq/dTEMwkX91ixGw8Rbtp4HSmR1dQymoMh0ZGKsKERe8/+KQsL2v8DRe3hQaaLE01tTMNhlZYIOqw7ey21qe+QpiOwyctuY9C/wDxNEJI1tf50UX1taiiE5A7K4j+hT4/ea7Fri9cRawoxFuPfzNEJ3c66W1sO8dtIPHhQSDYc6iZufHgNE2QhONISjSrqyPa6jZ+INrw1pWYKCzGgG5jKpZgqipOwjuVlR4SpLMD6TNsd1F9pIuCR2VT9R6in61TjyevC8aNGFN1Nr7lUH8Xzrr3B1XpLdDyHOdCj7VeAPIEYyAhlXadbnsrJYucQ3rWBhvZ42BOx+Oltdfw28Kw8x2YWChRgGqO7srOx+r4yGuRgRkQlSp79jTcGbJGWLNM5Y7ASx01IYXKjwqxxMlctJHTRUfZbwFzc/Gs1lZYl9WW9/pKX0BLKGVdOf4jU3puQOm9PGMLyZUrs7ngF3WtrzNUcTKcZN7Wpq1OppSWczhnJjDKtchtQdy7kn6zQ8vCk5eHGoGF1NMnKkwyS80UK5DbVugRmMa3fgWJBtU/kLi3jXTxZBkW8AgE6V3I6zi5cRxOUYio3pC/dpTMWmTlcjeID/hToIK6cKagUrkZR5Exbb//ADqyVx+/j2WoooohORexAOttC3C/K/dVdH1bFjT0svdBPFdXjPmuy8dhXQ8dB2VYEk2t8ayPuSE/qS2Pl+jkZESn0poi8R9PQG6bSS19WDaGs/KfIiX4yAQQDdtQ6fKaOLjTJk/G4Y1BIt+6o1mpGXilsdFlUnK3CArqGKi9r8j3Ux1fEGb07Ixju9QrvhEYBcyJ5lCBrXJ8axyBw8Ejfly3QOoKgPodeYbdwNX461JLBjq0e+cMGck2Doo1Hc3bVGPnKwYZRbUdmo6ETdk/WZMZxvx2uINTXS0g1HhMRlYs2av81DvQWkVlF2ANibNrfkw+NTcPCVFDwkkKu2WE6oyjsIubfcdasuuwZwZ+rwzR5XTsh/UicD0pYGby7JRbzruFt417RUFbmMZeKTHYhZEU/lueAUfun8JrM6FDZ6TqpGxB2nY42RcyBgLWraw/o43Q/wAS1kXGjggkAuFiR47i5F//AGvY2PYBztTTZkWNE0sxCKVMmRO58qxWuR2ncNTS5kks7xo4Bg9KKWS423JFgthwZiKzmYI+tdZ6Z7fmExh6hN/WnGW8rItzYDkObHkKrxYzkcJX/UjK4xYGytraK0r2n7R8Zu/aeNJB0s52QznI6pIcoCYBWWG1sZAi/QBFrt76scjqGNiu0ctyyi5VdSL6qD2E1U9Q6gMXIgw+moFh6bsigCtuViBt268dqi1RVdQZMiTzRCVxITfWS1gm3j5uZ5VqzcwoPx4RqrAV7KDf5zlYv15yEZ85qMgutH3XMdPlLtc6SVCVXz3IWNBuc8BZRpovOn8KD9PLlIXMjMyM8rEks2wbj2W7ByrOdGz2zOtrjSs3qLE+SGjA9NRHZNhP4bhtL6kVqYrepNY67hccPwiruEHKnJlYsWNASfSOnSZP2CJjyDEgACgE0/se/wBkev8A6UUfCitkxRknn21S9S6x7XSaHo3VMyBcqyvFExP8smwXc4B2M/IHiKujoOFZb3Z7b6N1jp5kyIxD1VY/6bJhU7ixA/PVB/MQfxcKrzUONgzWgihMt4935UsUs1dAN6+6WDYGPC26AwbZQFN7PvA1tqbfZURsCWBojEu6O0gQkhtsn4Y9w435HnVP7X6JH0qFoFyjOGO8q2qKw5Iq/Tfn21qhuiuloTvG0ltvnXiRqeFcNltY2MCOpnowcqBbvuI8wP17Yyuz9JkYUyA480bCx5eout7+NUEBTAEcTL6qsNjW1DqRqG7f2ca0uTik47zwLddqh0U7goUH6TzBPOs1lh4JmlyImKSWMiKSGUjgVtwbvNTcWAUsSF2FevSNxwhLstPORcO0sP51jnVw00kGLgKRGIE9NVF924a7zw8q8+QqLBEmB62SJgs8wMZ9MFXaNtfTDfVa4Ba1r117g6m+FkCPFsLxRGV5Lbn8oIFvw27Bxprp+F1LqsgfIX00ZS7TGzKFPmVtTbdcaClUlUU1tB7a+aWC38a36LQHXU9fjOenmTOyTFEhRV3GZgDtiUeXewHhp21ZdUjx52dyxQKLRm4UBTxueAN9WNTERIVSG6Y8ai0KhwLMD5t7Lq5Pf8KfSbEsdzJtPmUFSVDXvoX00OtGp1UUA6a/OIzkm4AkDYD6iQuh+1hjyDPnklj86vHCpAMgGoeZmu208NnMa1qItxmlN/JutstzsNb1Rx+7umPPLCJmzZIW2TpgQSZDxsBf+Z6QYC/jV3jOHMxXhvBv/uRW/brXa49lgsBHW4UY+3rPO8w5TlJzMGPZaagDoOkkfGik+NFXzNOD225cKzPuz231TrmI7dM6rk403pgDpplC4kpFtGICsh/iub1pDusx7j4DSuoz5EY6+UHTwHOiE+eJJerdMzX6c88sOXhylDCkpIWQG5K7TtbXnzrV9I617iz5wvV5VkxeB3qqyk20Eey3xvWr919D6hmos0wyepQwkusWEmMjItrkmF9hdgOxz4V57D7kgxHdIoJIQoFjsCStrwZT9H21j5GNmBC4ge/Ss6vBy4lYNkzkEenUL7zSekdPRlI/ToYZgPLId+wgdwtrUvJ6dk9SxJFnxxFloLpLD+WwH4RqSprzVfdytG0spmF3IWBZSWdQALvrZQPnUjpHWvd3uPMGL7dT0XJCy59yVgU6BmlbyJtHCwLdlYBwc5YlAFrvXrNufmYE/wCiZQWpUAAsf8PfNrL0U5uc/Us2F3xVVUVABulKoF2J/m1SHhwsuGHAycUQJHf019YgAJqzDv7b8eHCvPV94+4uk5B6Z1lmymx7rvdiJhGSVIJ4ODYkbtR21cYXudOpRli4yDjhzIkyBn9K28kR8TYDWxpW4udKXAMF0UivsG0bBnTMApdQyClpJUig3HWTer4HuESRj27gjPaYMXnJBEar5VDB2XzGnOk+zMrruGZPfKTxTRORiYsEiQp6bKLu/pbm3btLE+FP4Hurps0KSvkRqshVI3ikCgObblCPa3DThWg6d1mCYDHyMhHe5tKWAIvwSRTw7jWniZFSiZsdjVoG3Guwr2TNzsfJdWbHkLIKVRTXTr5d5aY8EOJCkGLEkMaKqBY1VLqg2ru2AXPeaTHHmnOn5hv47V499OkkfDlTWNr6500mYfYq11JxI9Zt1uVr2538Oyik+FFEI29wjn+Fj8jSp+XHfmq/9RSTWEUh/gb/AKmhbbI/9q/cKIRyqzq/t3ovXpYpur4i5UkCskRZmWwY3a+wgk+NWQNBI8RRCZdf7fe1xnzZ82ErhmX0MJSUxolQAD+Wp87MRdtxrSwxQ40Qgx4kgiU3EUShFv27VAF67v3UjEWtbwqJMzWT7Y6P7jxMmDqMW2aHMyBDmRWWePz7rBrG66/S2lZJP7WzRddihnyJJuhyCTbmwbVyI2C7kSZDcAMfLuX5V6L0xdqZbcnzMhx8Wt+yplwPjSrt8fGPkPm9w8JgIP7S9JVskZefPKrkfpHjCo8a8xKCGWQ9lrVoOl+yPbHSQjRYS5GQoUHJySZHLKLblUnat+dhatBb974Cg/s0pqRKnrEAVFVFG1FFlUcABwFcY222QObTObcyLLrS8G0tci4BpMYD+oNxrM44cNF076JEetztrRRuF9ut/D/GlFTCM5F/Rktb6Gv9hrsfQtv3R9lhRRRCL2dnKg91+61FFRCLp/nXOl+7nRRRJkTpl/0j7uP6jI8fzXt8qlr38fnRRSrt8fGM+/uHhFN760nI0UU0SNrb1NP3fjXWLbZNe/5z2v8ACiiiEf1oooqYT//Z";

let InputFieldsAll = {
    ClientePenhora:[],
    DetalhesPenhora: [],
};
var DisableByDetail = false;
const columnKeyMap = {
    numeroPedido: "Número de Pedido",
    numeroRegistoOrigem: "Número Registo Origem",
    numeroRegistoDestino: "Número Registo Destino",
    correlativas: "Correlativas"
}
var ivaDet = 0
var valorDet = 0
var applyedfilterFiltro;
var EntidadeArray = 0;
var EntidadeArrayOrdenante = 0;



class CriacaoNIBS extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            linkData: {
                filters:[] 
            },
            availableOptions: ['Option 1', 'Option 2', 'Option 3', 'Option 4'],
            chosenOptions: [],
            certProcIVDest: [],
            finalDataArray: [],
            show: false,
            isRemarkSet: false,
            mandatoryMissing: false,
            headName: "Conta",
            sendData: {
                processomento: {
                    pmentos: [],
                },
                processo: {
                    bib: false,
                    seloIncorporado: false,
                    logo: false,
                    macrapropria: false,
                },
                Dataatual: new Date(),
                Ultimaobservacao: "",
                aprovodo: true,
            },
            filtersEnt: {
                Filters: { entityId: null },
                FiltersIn: null,
                FiltersLike: null,
                SortBy: "",
                IsSortTypeDESC: false,
                IsPagination: true,
                Page: 2,
                PageSize: 20,
              },
            // readOnly : false,
            readOnly: true,
            parsed: {},
            telkikTable: "",
            entityGrid: "",
            tituloList: [],
            processoTelkikTable: "",
            applyedfilter: {},
            resData: {},
            registoData: {},
            operation: {
                IDEntidadeDestino: 0,
                IDEntidadeOrdenante: 0,
              },
            filterData: [
                {
                    "Nº Registo": "a",
                    Produto: "a",
                    Cor: "a",
                    Álcool: "a",
                    Tipo: "a",
                    Ano: "a",
                    Doçura: "a",
                    "Acidez (%)": "a",
                    "Saldo Incial (Lts)": "a",
                    Madeira: "a",
                    "Velor energetico": "Velor energetico",
                    Carbohydratos: "Carbohydratos",
                    Proteinas: "Proteinas",
                    "Fibra Elimentor": "Fibra Elimentor",
                    Sodio: "Sodio",
                    "Rotulus aprovados": "xxxxx",
                },
            ],
            nullProcess: true,
            invoice: null
        };
        this.onListChange = (newAvailableOptions, newChosenOptions) => {
            this.setState({
              availableOptions: newAvailableOptions.sort(),
              chosenOptions: newChosenOptions.sort()
            });
        };
    }
    createState = () => {
        if (this.props.linkData && this.props.linkData.columnkeyMap) {
            let columnkeyMap = this.props.linkData.columnkeyMap;
            let columnlist = Object.keys(columnkeyMap).map(function (key) {
                return { field: columnkeyMap[key], columnMenuType: 'checkbox' }
            });
            this.setState({
                columnlist,
                tabsComponentsView: null,
                Tab: this.props.Tab,
                entity_details: this.props.entity_details,
                currency_list: this.props.entity_details,
                tax_list: this.props.entity_details,
                TransMethods_list: this.props.entity_details,
                CalculationTabs: null,
                filters: this.props.linkData.filters
            }, () => {
                if (!this.props.singleentity) {
                    this.getListData();
                }
                this.tabsCalculation()
                this.tabSectionView()
            })
        }
    }
    

    redirectScreen = () => {
       
        let url = "/Conta";
        

        this.props.history.push({
            pathname: url || "/Conta",
           
        });
    };

    handlePopUpsubmit = (data) => {
        let { finalDataArray } = this.state;
        // finalDataArray=[...finalDataArray,data];
        finalDataArray = [
            ...finalDataArray,
            { discritivo: data.discritivo, titulo: data.id },
        ];
        let tableRowData = { ...data };
        let newData = { ...this.state.sendData };
        newData["processomento"] = { ...newData.processomento };
        newData["processomento"]["pmentos"] = [
            ...newData.processomento.pmentos,
            tableRowData,
        ];
        this.setState(
            {
                sendData: newData,
                show: false,
                finalDataArray,
            },
            () =>
                this.createTabel(
                    "processomento",
                    this.state.sendData.processomento.pmentos
                )
        );
    };

    createPDF = (type) => {
        var doc = new jsPDF("p", "pt", "a4");
        if (type === "Outros Formatos") {
            this.state.resData.imagens &&
                this.state.resData.imagens.map((imageData, i) => {
                    doc.addImage(imageObj, "PNG", 150, 100, 350, 150);
                    if (i < this.state.resData.imagens.length - 1) {
                        doc.addPage();
                    }
                });
            doc.save(type);
        } else if (type === "document") {
            let image =
                this.state.resData &&
                this.state.resData.características_do_rotulo &&
                this.state.resData.características_do_rotulo
                    .documentodecedencia; // use this code but it break so commented for now
            // let image = imageObj
            // doc.addImage(image, 'PNG', 150, 100, 350, 150);
            console.log("image", image);
            var a = document.createElement("a"); //Create <a>
            a.href = "data:image/png;base64," + image; //Image Base64 Goes here
            a.download = "Image.png"; //File name Here
            a.click();
        }
    };
   
    handleSubmit = async () => {
        var identidade = EntidadeArray;
        var ativoCheck = $("#ativo").is(":checked");

        if(window.location.search != ""){
            let data3 = {
                idEntidade : itemsDetalhes.idEntidade
            }
            let res2 = await services.apiCall.requestApi(
                "/Receita/GETNibsDisp",
                data3,
                "get"
            );

            if(res2 != undefined && res2.idEntidadeNIB != itemsDetalhes.idEntidadeNIB){
                if(ativoCheck == true  && res2.ativo == true){
                    Swal.fire({
                        title: 'Têm outro IBAN ativo nesta entidade',
                        text: 'Deseja inativar o existente?',
                        showDenyButton: true,
                        showCancelButton: false,
                        confirmButtonText: 'Sim',
                        denyButtonText: `Não`,
                    }).then((result) => {
                        if (result.isConfirmed) {
                        ativoCheck = true;
                            this.handleAfterSubmitFunction(ativoCheck);
                        } else if (result.isDenied) {
                            ativoCheck = false;
                            this.handleAfterSubmitFunction(ativoCheck);
                        }
                    })
                }else{
                    this.handleAfterSubmitFunction(ativoCheck);
                }
            }else{
                this.handleAfterSubmitFunction(ativoCheck);
            }
        }else{
            if($("#nib").val() == ""){
                Swal.fire({
                    icon: 'error',
                    title: 'O campo IBAN é de preenchimento obrigatório',
                    text: 'Preencha com valores válidos e volte a submeter',
                })
            }else{
                const res1 = iban().validate({
                    value: $("#nib").val().replace(/ /g,''),
                    options: {
                        message: 'The value is not a valid IBAN',
                    },
                });
                if(res1.valid == true){
                    let data4 = {
                        idEntidade : identidade
                    }
                    let res5 = await services.apiCall.requestApi(
                        "/Receita/GETNibsDisp",
                        data4,
                        "get"
                    );
                    if(res5 != undefined){
                        if(ativoCheck == true  && res5.ativo == true){
                            Swal.fire({
                                title: 'Têm outro IBAN ativo nesta entidade',
                                text: 'Deseja inativar o existente?',
                                showDenyButton: true,
                                showCancelButton: false,
                                confirmButtonText: 'Sim',
                                denyButtonText: `Não`,
                            }).then((result) => {
                                if (result.isConfirmed) {
                                ativoCheck = true;
                                    this.handleAfterSubmitFunction(ativoCheck);
                                } else if (result.isDenied) {
                                    ativoCheck = false;
                                    this.handleAfterSubmitFunction(ativoCheck);
                                }
                            })
                        }else{
                            this.handleAfterSubmitFunction(ativoCheck);
                        }
                    }else{
                        this.handleAfterSubmitFunction(ativoCheck);
                    } 
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'O IBAN inserido não é válido',
                        text: 'Preencha com valores válidos e volte a submeter',
                    })
                }
            }
            
        }
    };

    handleAfterSubmitFunction = async (ativoCheck) => {
        var identidade = EntidadeArray;
        var gestaoDocumental = $("#numeroGestaoDocumental").val();
        var nib =  $("#nib").val().replace(/ /g,'');
        var irrevogavel = $("#irrevogavel").is(":checked");
        var numeroProcesso = $("#numeroProcesso").val();
        var titular = $("#Titular").val();
        var outrosTitulares = $("#OutrosTitulares").val();

        if(window.location.search != ""){
            var idEntidadeNIB =  itemsDetalhes.idEntidadeNIB;
            let data2 = {
                idEntidade: itemsDetalhes.idEntidade,
                Ativo : ativoCheck,
                Irrevogavel: irrevogavel,
                NumeroProcessoGestaoDocumental: numeroProcesso,
                LoggedUser: window.localStorage.getItem('username'),
                IDEntidadeNIB: idEntidadeNIB,
            }
            let res = await services.apiCall.requestApi(
                "/Receita/SubmeterNIBS",
                data2,
                "post"
            );
            if (res) {
                this.redirectScreen();
            }
        }else{
            let data = {
                idEntidade: identidade,
                Ativo : ativoCheck,
                NumeroGestaoDocumental: gestaoDocumental,
                NIB: nib,
                Irrevogavel: irrevogavel,
                NumeroProcessoGestaoDocumental: numeroProcesso,
                LoggedUser: window.localStorage.getItem('username'),
                IDEntidadeNIB: null,
                Titular: titular,
                Outrostitulares : outrosTitulares
            }
            let res = await services.apiCall.requestApi(
                "/Receita/SubmeterNIBS",
                data,
                "post"
            );
            if (res) {
                this.redirectScreen();
            }
        }
    };



    ActionPerform = () => { };

    columnlist = Object.keys(columnKeyMap).map(function (key) {
        return { field: columnKeyMap[key], columnMenuType: "checkbox" };
    });
    searchEntidade = (e) => {
        console.log("hey");
        console.log(e);
        let entidades = []
        
        if (e == ""){
          return;
        }
    
        const filters = {"Nome" : e , "NIF" : e};
        
        (async () => {
            var Validanumero = /^\d+$/.test(e)
            if(Validanumero == false){
                const filters = {
                    "Nome" : e 
                };
                entidades = await services.apiCall.requestApi(
                    "/Entidades/ViewEntidadesFiscalizacao",
                    filters,
                    "get"
                );
            }else{
                const filters = {
                    "NIF" : e,
                };
                entidades = await services.apiCall.requestApi(
                    "/Entidades/ViewEntidadesFiscalizacao",
                    filters,
                    "get"
                );
            }
            
    
            this.setState({ entidades })
            // entidades.map((entidade) => (
            //   console.log({value: entidade.codEntidade, label: entidade.nome})
            // ));
        })()
    }

    createTabel = (module, data) => {
        console.log("800 in the data ", data);
        console.log("800 in the column list", this.columnlist);

        const columnList = Object.keys(columnKeyMap).map((key) => ({
            field: columnKeyMap[key],
            columnMenuType: "checkbox",
        }))

        if (module === "registo") {
            let telkikTable = (
                <TlkTable
                    notGroup={true}
                    noDownloadButton={true}
                    pageable={false}
                    date={new Date()}
                    notAction={true}
                    forRutoloDetail={true}
                    viewFor={"rotulos"}
                    noFilterShow={true}
                    modulename={"rotulos"}
                    deleteFunc={(id) => this.handleDelete(id)}
                    list={data}
                    columnlist={columnList}
                    ActionPerform={(action, id) =>
                        this.ActionPerform(action, id)
                    }
                />
            );

            this.setState({ telkikTable });
        }
    };

    isRemarkSet = () => {
        this.setState({
            isRemarkSet: true,
        });
    };

    

    componentDidMount() {
       // TableCriacaoPenhora.removeAllrows()
        
        DisableByDetail = false;
        //this.getTituloList();
        let parsed = queryString.parse(window.location.search);
        console.log("parsed in mount", parsed);
        console.log("PROPS: ", this.props);
        const queryParams = queryString.parse(window.location.search)
        const token = queryParams.idnib
        console.log(token ,"QUERY")

        this.setState(
            {
                parsed,
                readOnly: parsed.evaluator ? false : true,
                estado: parsed.estado,
                data:[]
            },

            () => {
                if (parsed.idPedidoTransferencia) {
                    this.getTipoDocumento(parsed.idPedidoTransferencia);
                }
            }
        );
        
        (async () => {
           
            // const datapagamento = {}
            // const estadoPenhora = await services.apiCall.requestApi(
            //    "/Receita/GetEstadosPenhora",
            //    datapagamento,
            //    "get"
            // );
            
            // var strHTML = "<option value='0' selected>Selecione...</option>";
            // for (let index = 0; index < estadoPenhora.length; index++) {
            //   var idPenhoraEstado = estadoPenhora[index].idPenhoraEstado;
            //   var penhoraEstado = estadoPenhora[index].penhoraEstado;
            // strHTML = strHTML + "<option value='" + idPenhoraEstado + "'>" + penhoraEstado + "</option>";
            // } 

            //$("#EstadoPenhora").html(strHTML);
    
                if(window.location.search != ""){
                    if(token){
                        const dataToken = {"idEntidadeNIB": token}
                        var Detalhes = await services.apiCall.requestApi(
                           "Receita/GetDetailsNibs",
                           dataToken,
                           "get"
                        );
                    }
                   
                    if(Detalhes){
                        console.log(Detalhes)
                        itemsDetalhes = Detalhes;
                        DisableByDetail = true
                       
                        $("#entidadeNameDetails").text(Detalhes.nome)
                        $("#entidadeNameDetails").val(Detalhes.idEntidade)
                        $("#SearchEntidadeBox").css("display" , "none")

                        $("#irrevogavel").attr("checked" , Detalhes.irrevogavel)
                        if(Detalhes.irrevogavel == true){
                            $("#NProcesso").removeClass("d-none");
                            $("#numeroProcesso").val(Detalhes.numeroProcessoGestaoDocumental)
                        }
                        var dateCriado = Detalhes.dataCriado;
                        dateCriado = new Date(dateCriado);
                        var day = dateCriado.getDate() < 10 ? "0"+dateCriado.getDate() : dateCriado.getDate();
                        var month = dateCriado.getMonth() +1 < 10 ? "0"+(dateCriado.getMonth() +1) : dateCriado.getMonth() +1;
                        var year = dateCriado.getFullYear();
                        dateCriado = day + "/" +  month + "/" + year;
                        

                        $("#CriadoPor").text(Detalhes.criadoPor)
                        $("#CriadoPor").val(Detalhes.criadoPor)
                        $("#DataCriado").text(dateCriado)
                        $("#DataCriado").val(dateCriado)
                        $("#nib").text(Detalhes.nib)
                        $("#nib").val(Detalhes.nib)
                        $("#numeroGestaoDocumental").text(Detalhes.numeroGestaoDocumental)
                        $("#numeroGestaoDocumental").val(Detalhes.numeroGestaoDocumental)
                        $("#OutrosTitulares").text(Detalhes.outrostitulares)
                        $("#OutrosTitulares").val(Detalhes.outrostitulares)
                        $("#Titular").text(Detalhes.titular)
                        $("#Titular").val(Detalhes.titular)
                        $("#ativo").attr("checked" , Detalhes.ativo)
                    }
                    

                }else{
                    $("#botaoAdicionarNovo").attr("disabled" , true)
                }
            }
         )();
                
    }
     /*Para obter detalhes de uma única entidade usando api */
     

/////// preenche a drop do tipo de auto ////
handleChangeEntidade = (e) => {
    EntidadeArray = e;
    this.setState({ operation: {...this.state.operation.IDEntidadeDestino = e } });
    console.log("ENTIDADEEEEE" , this.state.operation.IDEntidadeDestino)
}

getTipoDocumento() {
    (async () => {
  
    const data = {}
            const TipoDocumento = await services.apiCall.requestApi(
               "/Receita/GetTipoFatura",
               data,
               "get"
            );
            
            var strHTML = "<option value='0' selected>Selecione...</option>";
            for (let index = 0; index < TipoDocumento.length; index++) {
              var idTipoFatura = TipoDocumento[index].idTipoFatura;
              var descricao = TipoDocumento[index].descricao;
            strHTML = strHTML + "<option value='" + idTipoFatura + "'>" + descricao + "</option>";
            }  
            $("#TipoDocumento").html(strHTML);
        })();
}

/////// end preenche a drop das familias ////

    componentDidUpdate(preprops) { }
    
    
    handleFilter = (data) => {
        console.log("ENTIDADEEEEEEEEEEE" , data)
        // this.setState({
        //     filterData: data
        // }, () => this.createTabel())
    }
    getFilters = (customfilters) => {
        let applyedfilter = { ...customfilters.filterCheckbox, ...customfilters.filters }
        delete applyedfilter.entity;
        applyedfilter.local = window.localStorage.getItem('Local');
        console.log("filter", applyedfilter);
        applyedfilter = applyedfilter.entityIdFilter
        this.setState({
            applyedfilter,
            date:new Date()
        },
       // applyedfilterFiltro = applyedfilter.entityIdFilter,
        console.log("ENTIDADEEEEE" , this.state.applyedfilter)
        );
    }

    getTableDate = (type, data) => {
        console.log("data 123: ", data)
        if (type === "Processamento") {
            Object.keys(columnKeyMap).map((key) => {
                console.log(key,"key")
                console.log(columnKeyMap[key],"key2")
                 data.map((el) => {
                     console.log(el)
                    if (key === "numeroPedido") {
                        el[columnKeyMap[key]] = el.numeroPedido;
                    } 
                    else if (key === "numeroRegistoOrigem") {
                        el[columnKeyMap[key]] = el.numeroRegistoOrigem;
                    } 
                    else if (key === "numeroRegistoDestino") {
                        el[columnKeyMap[key]] = el.numeroRegistoDestino;
                    } 
                    else if (key === "correlativas") {
                        el[columnKeyMap[key]] = el.correlativas;
                    } 
                });
            });
        }
    };

    formatTableData = (data) => {
        console.log("formatTableData: ", data)
        return data.map((_row, index) => {
            Object.keys(_row).map(function (key) {
                if (key === "indiceCalorico") {
                    Object.keys(_row[key]).map((_k) => {
                        _row[Lang.langCheck.langRequest(_k)] = _row[key][_k];
                    });
                } else {
                    _row[Lang.langCheck.langRequest(key)] = _row[key];
                }
            });
        });
    };

    createTable = async (type, data) => {
        const columnlist = Object.keys(columnKeyMap).map(function (key) {
            return { field: columnKeyMap[key], columnMenuType: "checkbox" };
        });

        console.log("columnlist", columnlist);
        console.log("data", data);


        let telkikTable = (
            <TlkTable
                notGroup={true}
                noDownloadButton={true}
                pageable={false}
                date={new Date()}
                notAction={true}
                viewFor="marcas"
                forRutoloDetail={true}
                noFilterShow={true}
                modulename="marcas"
                deleteFunc={(id) => this.handleDelete(id)}
                list={data}
                columnlist={columnlist}
                ActionPerform={(action, id) =>
                    this.ActionPerform(action, id)
                }
            />
        );

        this.setState({ telkikTable });
    }

    returntoFirst = async (obs) => {
        let data = {
            VoltarDoSegundo: true,
            Nprocesso: +this.state.parsed.id,
            Ultimaobservacao: obs,
            NumeroAvaliacao: 2,
            processmentos: {
                Pmentos: [],
            },
        };

        let res = await services.apiCall.requestApi(
            "/SIVDP/evelution_approvel_next_lavel",
            data,
            "post"
        );
        if (res) {
            $("#popup-return").trigger("click");
           
            this.props.history.push({
                pathname: "/Conta",
                //state: { paramoption: paramoption },
            });
        }
    };

    handleLibertar = async () => {
        let res = await services.apiCall.requestApi(
            "/SIVDP/libertar",
            { id: +this.state.parsed.id },
            "post"
        );

        if (res) {
            let paramoption = {
                name: "Pendentes",
                url: "/Conta",
                tableName: "RotulosPendentes",
            };
            this.props.history.push({
                pathname: "/Conta",
                state: { paramoption: paramoption },
            });
        }
    };

    handleChange = (e, type) => {
        if(type == "toggle"){
            if(e.target.checked== true){
                $("#NProcesso").removeClass("d-none");
            }else{
                $("#NProcesso").addClass("d-none");
            }
        }
    };
    //// grid
    displayPDF(e) {
        e.preventDefault();
        //The PDFContent bytes are mapped to an input element called pdfString
        // if($('#pdfString').val() == '')
        //     return;
        var file = this.b64toBlob(this.state.invoice, 'application/pdf');
        //If the browser is IE or Edge
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(file);
        }
        else {
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL);
        }
    }

    b64toBlob(b64Data, contentType, sliceSize) {
          contentType = contentType || '';
          sliceSize = sliceSize || 512;

          var byteCharacters = atob(b64Data);
          var byteArrays = [];

          for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            var slice = byteCharacters.slice(offset, offset + sliceSize);

            var byteNumbers = new Array(slice.length);
            for (var i = 0; i < slice.length; i++) {
              byteNumbers[i] = slice.charCodeAt(i);
            }

            var byteArray = new Uint8Array(byteNumbers);

            byteArrays.push(byteArray);
          }

          var blob = new Blob(byteArrays, {type: contentType});
          return blob;
    }
    
    handleChangeInput = object => {
        // const { value, maxLength } = event.target;
        // const message = value.slice(0, maxLength);
    
        // if (object.target.value.length > object.target.maxLength) {
        //     object.target.value = object.target.value.slice(0, object.target.maxLength)
        //     this.setState({ phone: object.target.value });
        //   }

       
      };

    render() {
        // console.log("data",this.state.sendData, this.state.resData)
        console.log("submetidopor:");
        console.log(this.state);

        if (this.state.invoice === null || this.state.invoice === ""){
            InputFieldsAll = {
                ClientePenhora:[],
                DetalhesPenhora: [],
            };
        } 
        else{
            InputFieldsAll = {
                ClientePenhora:[],
                DetalhesPenhora: [],
            };
        }

        let leftNavFields = {ClientePenhora: [], ...InputFieldsAll };
        let parsed = queryString.parse(window.location.search);
        let estadoQuery = parsed.estado;
        let processmentoLabel = this.state.resData.processmentos || {};
        let processoLabel =
            (this.state.resData && this.state.resData.processo) || {};
        console.log(processoLabel);
        return (
            <div className="dashboard">
                {estadoQuery != null ?(
                    <>
                    <FormnavBar
                        showReturnButton={
                            this.state.resData.evaluationStatus !== "under_review1"
                        }
                        pendingCases={
                            this.state.resData.evaluationStatus ===
                            "review2_pending" ||
                            this.state.resData.evaluationStatus ===
                            "under_review2" ||
                            this.state.resData.evaluationStatus === "under_review1"
                        }
                        
                        handleLibertar={() => this.handleLibertar()}
                       
                        to={"/" + (this.state.parsed.from || "rotulos")}
                       handleSubmit={(data, url) => this.handleSubmit(data, url)}
                        returntoFirst={(data) => this.returntoFirst(data)}
                        estado={this.state.resData.estado}
                        numeroAvaliacao={this.state.resData.numeroAvaliacao}
                        parsed={this.state.parsed}
                        type="parcelas"
                        headName="Trasf"
                        evaluator={
                            this.state.resData.evaluationStatus ===
                            "review2_pending" ||
                            this.state.resData.evaluationStatus ===
                            "under_review2" ||
                            this.state.resData.evaluationStatus === "under_review1"
                        }
                    />
                    </>
                ):(
                    <>
                    <FormnavBar
                        showReturnButton={
                            this.state.resData.evaluationStatus !== "under_review1"
                        }
                        pendingCases={
                            this.state.resData.evaluationStatus ===
                            "review2_pending" ||
                            this.state.resData.evaluationStatus ===
                            "under_review2" ||
                            this.state.resData.evaluationStatus === "under_review1"
                        }
                        
                        handleLibertar={() => this.handleLibertar()}
                       
                        to={"/" + (this.state.parsed.from || "Conta")}
                        handleSubmit={(data, url) => this.handleSubmit(data, url)}
                        returntoFirst={(data) => this.returntoFirst(data)}
                        estado={this.state.resData.estado}
                        numeroAvaliacao={this.state.resData.numeroAvaliacao}
                        parsed={this.state.parsed}
                        type="parcelas"
                        headName={this.state.headName}
                        evaluator={
                            this.state.resData.evaluationStatus ===
                            "review2_pending" ||
                            this.state.resData.evaluationStatus ===
                            "under_review2" ||
                            this.state.resData.evaluationStatus === "under_review1"
                        }
                    />
                    </>
                )}
               
                <div className="full-container edit-ward">
                    <FormleftNev
                        InputFieldsAll={leftNavFields}
                        navFor="Receita"
                       
                    />
                    <div className="right-section right-section-processo">
                        <div className="row top-serch">
                        {this.state.parsed ? (
                                <div
                                    className="bg-white middle p20"
                                   
                                    id="ClientePenhora"
                                >
                                    <div className="head">
                                        <h2>
                                            {Lang.langCheck.langRequest(
                                                "Entidade"
                                            )}
                                        </h2>
                                        <br></br>
                                        <p className="font-14"></p>
                                        
                                        {
                                    <div className="col-md-12">
                          
                                    <div className="input-box active-grey" id="SearchEntidadeBox">
                                        {/* <span>Entidade</span> */}
                                        <Select
                                        showSearch
                                        onSearch={(e) => this.searchEntidade(e)}
                                        optionFilterProp="children"
                                        // maxTagTextLength={ 3 }
                                        placeholder="Selecione a entidade"
                                        className="mov-Ent-Select DropEntidade"
                                        //value={this.state.data.idTipoFormulario}
                                        onChange={(e) => this.handleChangeEntidade(e)}
                                        style={{ width: "100%"}}
                                        >
                                        <Option disabled >Selecione a entidade destino</Option>
                                        {(this.state.entidades && !!this.state.entidades.length) && this.state.entidades.map((item, index) => (
                                            <Option key={index} value={item.codEntidade}>{item.nome + " - " + item.nif} </Option>
                                          
                                        ))}
                                        </Select>
                                    </div>
                                    <div id="EntidadeDiv">
                                    {/* <span>Entidade</span> */}
                                    <p id="entidadeNameDetails"></p>
                                    </div>
                                    </div>
                                   }
                                    </div>
                                </div>
                            ) : (
                                <>
                                    
                                </>
                            )}
                            {this.state.parsed && window.location.search != "" ? (
                                <div
                                    className="bg-white middle p20"
                                    id="DetalhesPenhora"
                                >
                                    <div className="head mb-0">
                                        <h2>
                                            {Lang.langCheck.langRequest(
                                                "Detalhes"
                                            )}
                                        </h2>
                                        <br></br>
                                        <p className="font-14"></p>
                                        
                                        <div className="row" style={{color: "black"}}>
                                           
                                            <div className="col-md-12 d-flex">
                                               <p className="pr-2" style={{fontWeight: "500"}}>Criado Por: </p><p id="CriadoPor"></p>
                                            </div>
                                            <div className="col-md-12 d-flex">
                                               <p className="pr-2" style={{fontWeight: "500"}}>Data de Criação: </p><p id="DataCriado"></p>
                                            </div>
                                            <div className="col-md-12 d-flex">
                                               <p className="pr-2" style={{fontWeight: "500"}}>IBAN: </p><p id="nib"></p>
                                            </div>
                                            <div className="col-md-12 d-flex">
                                               <p className="pr-2" style={{fontWeight: "500"}}>Gestão Documental: </p><p id="numeroGestaoDocumental"></p>
                                            </div>
                                            <div className="col-md-12 d-flex">
                                               <p className="pr-2" style={{fontWeight: "500"}}>Titular: </p><p id="Titular"></p>
                                            </div>
                                            <div className="col-md-12 d-flex">
                                               <p className="pr-2" style={{fontWeight: "500"}}>Outros Titulares: </p><p id="OutrosTitulares"></p>
                                            </div>
                                            <div className="col-md-12 pt-3 d-flex align-items-center">
                                                <div className="input-box active-grey">
                                                    <div class="custom-control custom-switch mt-4 ml-4">
                                                        <input type="checkbox" class="custom-control-input" name="irrevogavel" id="irrevogavel" onChange={(e) =>this.handleChange(e,"toggle")} />
                                                        <label class="custom-control-label labelswitchIrrevogavel" for="irrevogavel">Irrevogável</label>
                                                    </div>
                                                </div>
                                                <div className="input-box active-grey d-none ml-4" id="NProcesso">
                                                    <label className="input-label" style={{top: "-11px"}}>Número do Processo</label>
                                                    <input id="numeroProcesso" type="text" className="input-1"/>
                                                </div>
                                                <div className="input-box active-grey mt-4 ml-4">      
                                                    <div class="custom-control custom-switch">
                                                        <input type="checkbox" class="custom-control-input" name="ativo" id="ativo" />
                                                        <label class="custom-control-label labelswitchativo" for="ativo">Ativo</label>
                                                    </div>
                                                </div>
                                            
                                            </div>
                                            
                                            {/* <div className="col-md-12 d-flex">
                                               <p className="pr-2" style={{fontWeight: "500"}}>Entidade Ordenante: </p><p id="EntidadeOrdenante"></p>
                                            </div>
                                            <div className="col-md-12 d-flex">
                                                <p className="pr-2" style={{fontWeight: "500"}}>Data da Penhora: </p><p id="DataPenhora"></p>
                                            </div>
                                            <div className="col-md-12 d-flex">
                                                <p className="pr-2" style={{fontWeight: "500"}}>Data de Entrada: </p><p id="DataEntrada"></p>
                                            </div>
                                            <div className="col-md-12 d-flex">
                                                <p className="pr-2" style={{fontWeight: "500"}}>Valor da Penhora (€): </p><p id="ValorInicial"></p>
                                            </div>
                                            <div className="col-md-12 d-flex">
                                                <p className="pr-2" style={{fontWeight: "500"}}>Total Pago (€): </p><p id="TotalPago"></p>
                                            </div>
                                            <div className="col-md-12 d-flex">
                                                <p className="pr-2" style={{fontWeight: "500"}}>Valor em Divida (€): </p><p id="ValorEmDivida"></p>
                                            </div>
                                            <div className="col-md-12 d-flex">
                                                <p className="pr-2" style={{fontWeight: "500"}}>Criado Por: </p><p id="CriadoPor"></p>
                                            </div>
                                            <div className="col-md-12 pt-3 d-flex align-items-center">
                                                <div className="input-box active-grey drop-down-box">
                                                    <label className="input-label" style={{top: "-11px"}}>Estado</label>
                                                    <select className="custome-drop-down" name="EstadoPenhora" id="EstadoPenhora">
                                                       
                                                    </select>
                                                </div>
                                                <div className="input-box active-grey">
                                                       
                                                        <div class="custom-control custom-switch mt-4 ml-4">
                                                            <input type="checkbox" class="custom-control-input" name="irrevogavel" id="irrevogavel" onChange={(e) =>this.handleChange(e,"toggle")
                                                            } />
                                                            <label class="custom-control-label labelswitchIrrevogavel" for="irrevogavel">Irrevogável</label>
                                                        </div>
                                                        
                                                 </div>
                                                 <div className="input-box active-grey d-none ml-4" id="NProcesso">
                                                    <label className="input-label" style={{top: "-11px"}}>Número do Processo*</label>
                                                    <input id="numeroProcesso" type="number" className="input-1" required/>
                                                </div>
                                            </div> */}
                                            
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <>
                                   <div
                                    className="bg-white middle p20"
                                    id="DetalhesPenhora"
                                >
                                    <div className="head mb-0">
                                        <h2>
                                            {Lang.langCheck.langRequest(
                                                "Detalhes"
                                            )}
                                        </h2>
                                        <br></br>
                                        <p className="font-14"></p>
                                        
                                        <div className="row d-flex justify-content-flex-start alignt-items-baseline flex-wrap-nowrap" style={{color: "black"}}>
                                            <div className="col-md-1 ">
                                                <div className="input-box active-grey">
                                                            
                                                    <div class="custom-control custom-switch">
                                                        <input type="checkbox" class="custom-control-input" name="ativo" id="ativo" />
                                                        <label class="custom-control-label labelswitchativo" for="ativo">Ativo</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-3 ">
                                                <div className="input-box active-grey" id="NGestaoDocumental">
                                                    <label className="input-label" style={{top: "-11px"}}>Gestão Documental</label>
                                                    <input id="numeroGestaoDocumental" type="text" className="input-1" />
                                                </div>
                                            </div>
                                            <div className="col-md-4 ">
                                                <div className="input-box active-grey">
                                                <label className="input-label" style={{top: "-11px"}}>IBAN*</label>
                                                <IBANInput
                                                />
                                                
                                                </div>
                                            </div>
                                            {/* <div className="col-md-3 ">
                                                <div className="input-box active-grey">
                                                    <label className="input-label" style={{top: "-11px"}}>IBAN*</label>
                                                    <input id="nib" type="text" className="input-1" maxLength={25} onChange={this.handleChangeInput} />
                                                </div>
                                            </div> */}
                                            <div className="col-md-2 ">
                                                <div className="input-box active-grey">
                                                    <div class="custom-control custom-switch">
                                                        <input type="checkbox" class="custom-control-input" name="irrevogavel" id="irrevogavel" onChange={(e) =>this.handleChange(e,"toggle")
                                                        } />
                                                        <label class="custom-control-label labelswitchIrrevogavel" for="irrevogavel">Irrevogável</label>
                                                    </div>
                                                </div>
                                            </div>    
                                            <div className="col-md-3 ">
                                                <div className="input-box active-grey d-none" id="NProcesso">
                                                    <label className="input-label" style={{top: "-11px"}}>Número do Processo</label>
                                                    <input id="numeroProcesso" type="text" className="input-1"/>
                                                </div>
                                            </div>
                                            <div className="col-md-12 ">
                                                <div className="input-box active-grey">
                                                    <label className="input-label" style={{top: "-11px"}}>Titular</label>
                                                    <input id="Titular" type="text" className="input-1"/>
                                                </div>
                                            </div>
                                            <div className="col-md-12 ">
                                                <div className="input-box active-grey">
                                                    <label className="input-label" style={{top: "-11px"}}>Outros titulares</label>
                                                    <textarea className="form-control heigh-auto" rows="3" name="OutrosTitulares" id="OutrosTitulares"></textarea>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> 
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default CriacaoNIBS;
